import { useFormikContext } from 'formik';
import { useRef, useEffect } from 'react';
import FormFields from './FormFields';
import { type CreateMobilityFormValues } from './types';

const CreateMobilityForm = () => {
    const {
        values: { moduleId },
        setFieldValue,
    } = useFormikContext<CreateMobilityFormValues>();

    // reset stockIds when moduleId update
    const lastModuleId = useRef(moduleId);
    useEffect(() => {
        if (lastModuleId.current !== moduleId) {
            setFieldValue('stockIds', []);

            lastModuleId.current = moduleId;
        }
    }, [moduleId, setFieldValue]);

    return <FormFields isUpdate={false} />;
};

export default CreateMobilityForm;
